import React from 'react';
import { useSearchParams } from 'react-router-dom';

const CheckYourEmail = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  return (
    <div className="govuk-width-container mt-10 mb-10">
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-three-quarters">
          <h1 className="govuk-heading-xl">
            Please check your new email address
          </h1>
          <p className="govuk-body">
            We&apos;ve just sent an email to{' '}
            <strong>
              <span>{email}</span>
            </strong>
            . You will be able to verify your new email address by following the
            steps provided.
          </p>
          <p className="govuk-body">
            If haven&apos;t received the email in 5 minutes please check your
            junk or spam folder.
          </p>
          <p className="govuk-body">
            The link emailed to you will expire in one hour. If you do not click
            on the link emailed to you and confirm, the link will expire in one
            hour.
          </p>
          <p className="govuk-body">
            If it has still not arrived we can{' '}
            <a
              target="_self"
              className="govuk-link govuk-link--no-visited-state"
              href="/resend-activation-email/"
            >
              resend your activation email
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckYourEmail;
